import { render, staticRenderFns } from "./SingleProductTab.vue?vue&type=template&id=45be8e14&scoped=true&"
import script from "./SingleProductTab.vue?vue&type=script&lang=js&"
export * from "./SingleProductTab.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductTab.vue?vue&type=style&index=0&id=45be8e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be8e14",
  null
  
)

export default component.exports